var render, staticRenderFns
import script from "./floorlist.vue?vue&type=script&lang=js&"
export * from "./floorlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067e06e5",
  null
  
)

export default component.exports